<template>
	<ChartCard
		:title="chart.title"
		icon="mdi-chart-bar"
	>
		<component
			:is="chart.chartType"
			v-if="chartHasData"
			:chart-data="processedChartData"
			:chart-options="processedChartOptions"
		/>
		<div v-else>
			No data available for selected filters.
		</div>
	</ChartCard>
</template>
<script>
import ChartCard from '../../../../../../shared/components/chart-card.vue'
import LineChart from '../../../../../../shared/components/chart/line-chart.vue'
import BarChart from '../../../../../../shared/components/chart/bar-chart.vue'
import RadarChart from '../../../../../../shared/components/chart/radar-chart.vue'
import PolarChart from '../../../../../../shared/components/chart/polar-chart.vue'
import PieChart from '../../../../../../shared/components/chart/pie-chart.vue'
import DoughnutChart from '../../../../../../shared/components/chart/doughnut-chart.vue'
import { getChartColorByIndex } from '../../../../../../shared/utils/getChartColorByIndex.js'

export default {
	components: {
		BarChart,
		LineChart,
		RadarChart,
		PolarChart,
		PieChart,
		DoughnutChart,
		ChartCard
	},
	props: {
		items: Array,
		selected: Function,
		chart: Object,
		palette: {
			type: String,
			default: 'default' // Default palette name
		}
	},
	data () {
		return {
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false
			}
		}
	},
	computed: {
		processedChartData () {
			if (!this.chart || !this.chart.chartData || !this.chart.chartData.datasets) {
				return { labels: [], datasets: [] }
			}

			const { labels, datasets } = this.chart.chartData
			const newDatasets = datasets.map((dataset, datasetIndex) => {
				const newDataset = { ...dataset }

				if (this.chart.chartType === 'PieChart' || this.chart.chartType === 'DonutChart' || this.chart.chartType === 'PolarChart') {
					newDataset.backgroundColor = dataset.data.map((_, dataIndex) => getChartColorByIndex(dataIndex, this.palette))
					newDataset.borderColor = newDataset.backgroundColor
				} else {
					const color = getChartColorByIndex(datasetIndex, this.palette)
					newDataset.borderColor = color
					newDataset.backgroundColor = color
				}

				// Apply tension for line charts (always use smoothing with 0.4 tension)
				if (this.chart.chartType === 'LineChart') {
					newDataset.tension = 0.4
				}

				return newDataset
			})

			return {
				labels,
				datasets: newDatasets
			}
		},
		processedChartOptions () {
			const options = { ...(this.chart.chartOptions || {}) }
			return options
		},
		chartHasData () {
			return this.chart.chartData.datasets.length
		}
	}
}
</script>
